import api from './api';
import type { Comment, CreateCommentRequest } from '../types';
import type { PaginatedResult } from './reviews';

export const commentsService = {
  async getByReviewId(reviewId: string, page = 1, pageSize = 20): Promise<PaginatedResult<Comment>> {
    const response = await api.get<PaginatedResult<Comment>>(`/comments/review/${reviewId}`, {
      params: { page, pageSize },
    });
    return response.data;
  },

  async create(reviewId: string, data: CreateCommentRequest): Promise<Comment> {
    const response = await api.post<Comment>(`/comments/review/${reviewId}`, data);
    return response.data;
  },

  async update(commentId: string, data: CreateCommentRequest): Promise<Comment> {
    const response = await api.put<Comment>(`/comments/${commentId}`, data);
    return response.data;
  },

  async delete(commentId: string): Promise<void> {
    await api.delete(`/comments/${commentId}`);
  },

  async adminDelete(commentId: string): Promise<void> {
    await api.delete(`/comments/${commentId}/admin`);
  },

  async like(commentId: string): Promise<void> {
    await api.post(`/comments/${commentId}/like`);
  },

  async unlike(commentId: string): Promise<void> {
    await api.delete(`/comments/${commentId}/like`);
  },
};
